import "core-js/modules/esnext.async-iterator.reduce.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.reduce.js";
import camelcaseKeys from "camelcase-keys";
import parse from "style-to-object";
var AttributeEnum = /*#__PURE__*/function (AttributeEnum) {
  AttributeEnum["Style"] = "style";
  return AttributeEnum;
}(AttributeEnum || {}); // Attributes from backend is using class rather than className
export function normalizeJsxAttribute(attributes) {
  function replaceToJsxAttribute(key) {
    return key.replace(/^class$/, "className");
  }

  // Style value sample: border-radius:12px
  function massageStyleAttribute(value) {
    const styleObject = parse(value);
    // Suppress react warning by camelCasing the css string
    if (styleObject) return camelcaseKeys(styleObject);
    return null;
  }
  if (!attributes) return attributes;
  return Object.keys(attributes).reduce((accumulator, key) => {
    const value = attributes[key];
    if (key === AttributeEnum.Style) {
      accumulator[replaceToJsxAttribute(key)] = massageStyleAttribute(value);
    } else {
      accumulator[replaceToJsxAttribute(key)] = value;
    }
    return accumulator;
  }, {});
}